import { render } from "./TheFooter.vue?vue&type=template&id=63e0838d"
const script = {}

import exportComponent from "D:\\victo\\Documents\\Projects\\RawData\\product-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__